import React from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";
import { Typography } from "@mui/material";
import { get, find } from "lodash";
import Field from "../Field";
import BogoField from "./BogoField";
import { useTranslation } from "react-i18next";

const CustomValuesField = ({ values, template }) => {
  const { id } = template;
  const { t } = useTranslation();

  if (id === "bogo") {
    return <BogoField buyValue={values.buyValue} getValue={values.getValue} />;
  }

  if (id === "dollar-off") {
    return (
      <Field
        title={t("offer_create.basic_dollar_label")}
        value={
          <NumericFormat
            value={values.dollarValue}
            prefix="$"
            displayType="text"
            renderText={(value) => (
              <Typography variant="body2">{value}</Typography>
            )}
          />
        }
      />
    );
  }

  if (id === "percent-off") {
    return (
      <Field
        title={t("offer_create.basic_percentage_label")}
        value={
          <NumericFormat
            value={values.percentValue}
            suffix="%"
            displayType="text"
            renderText={(value) => (
              <Typography variant="body2">{value}</Typography>
            )}
          />
        }
      />
    );
  }

  if (id === "event") {
    const templateOption = find(
      template.template_options,
      { optionName: "eventType" },
      {},
    );
    const optionValues = templateOption.optionValues || [];
    const eventName = get(
      find(optionValues, { value: values.eventType }),
      "name",
    );

    return (
      <Field title={t("offer_create.basic_event_label")} value={eventName} />
    );
  }

  return null;
};

CustomValuesField.propTypes = {
  values: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
};

export default CustomValuesField;
